/**
 * 주입형 typed 도메인 이벤트 primitive (architecture-review §2 패러다임 규칙 3).
 *
 * - 알림 전용: "일어난 일"을 구독자에게 전파만 한다 — 이벤트로 커맨드 발행 금지.
 * - 전역 금지: 인스턴스를 보유한 객체를 통해서만 구독 가능 (의존이 시그니처에 보임).
 * - 첫 소비자: RefreshScheduler.flushed (G3 선택 갱신). 도메인 컨트롤러로의 확장은
 *   세밀한 무효화가 필요해지는 시점에 같은 타입으로.
 */
export type Unsubscribe = () => void;

export class Signal<T = void> {
  private listeners: Array<(payload: T) => void> = [];

  subscribe(listener: (payload: T) => void): Unsubscribe {
    this.listeners.push(listener);
    return () => {
      const idx = this.listeners.indexOf(listener);
      if (idx >= 0) this.listeners.splice(idx, 1);
    };
  }

  /** 등록 순서대로 동기 호출. 호출 중 구독/해제가 일어나도 이번 회차 목록은 불변(스냅샷). */
  emit(payload: T): void {
    for (const listener of [...this.listeners]) listener(payload);
  }

  get listenerCount(): number {
    return this.listeners.length;
  }

  clear(): void {
    this.listeners.length = 0;
  }
}
